type GlobalType = string | Array<string>

interface GlobalVars extends Record<string, GlobalType> {
  communityId: string
}

let vars: GlobalVars = {
  communityId: ''
}

function globals<T extends keyof GlobalVars>(name: T, value: GlobalVars[T] = ''): GlobalVars[T] {
  if (!value) {
    return vars[name] || ''
  }

  vars[name] = value

  return vars[name] || ''
}

export default globals

type Event<N extends string, T> = Record<N, T>

type GlobalEvents = Event<'quote', {username: string, content: string}> & Event<'edit_column', {editing: boolean}> & Event<'title_changed', {title: string}>

type Subscription = [string, (payload: any) => void]

const subscriptions: Array<Subscription> = []

export type UnsubscribeCallback = () => void

export function subscribe<T extends keyof GlobalEvents>(eventName: T, callback: (payload: GlobalEvents[T]) => void): UnsubscribeCallback {
  const subscription: Subscription = [eventName, callback]
  subscriptions.push(subscription)
  return () => {
    subscriptions.splice(subscriptions.indexOf(subscription), 1)
  }
}

export function publish<T extends keyof GlobalEvents>(name: T, payload: GlobalEvents[T]) {
  subscriptions.forEach(subscription => {
    if (subscription[0] === name) {
      subscription[1](payload)
    }
  })
}
